import React, { Suspense, lazy } from "react";
import Spinner from "./ui/spinner";
import MotionBackground from "./ui/motionBackground";
import SEO from "../seo/SEO";
import { SEO_PAGES, getBreadcrumbSchema } from "../seo/seoConfig";

const EnterpriseHero = lazy(() => import("./pages/for_Enterprise/enterprise-hero"));
const WhyPartner = lazy(() => import("./pages/for_Enterprise/whyPartner"));
const EnterpriseServices = lazy(() => import("./pages/for_Enterprise/enterprise-services"));
const OurEnterpriseProcess = lazy(() => import("./pages/for_Enterprise/our-enterprise-process"));
const KeyBenefits = lazy(() => import("./pages/for_Enterprise/key-benefits"));
const Testimonials = lazy(() => import("./pages/for-startup/testimonials"));
const FAQEnterpriseSection = lazy(() => import("./pages/for_Enterprise/faq-enterprise-section"));
const FreeEnterpriseConsultation = lazy(() => import("./pages/for_Enterprise/free_enterprise_consultation"));
const Footer = lazy(() => import("./footer"));

export const Enterprise = (props) => {
  const seo = SEO_PAGES.enterprise;
  return (
    <>
      <SEO
        {...seo}
        schemas={[
          getBreadcrumbSchema([
            { name: "Home", path: "/" },
            { name: "Enterprise", path: "/enterprise" },
          ]),
        ]}
      />
    <div id="For Enterprise">
      <MotionBackground>
        <div className="flex flex-col min-h-screen">
          <main className="flex-1">
            {" "}
            <Suspense fallback={<Spinner />}>
              <EnterpriseHero />
              <WhyPartner />
              <EnterpriseServices />
              <OurEnterpriseProcess />
              <KeyBenefits />
              <Testimonials />
              <FAQEnterpriseSection />
              <FreeEnterpriseConsultation />
              <Footer/>
            </Suspense>
          </main>
        </div>
      </MotionBackground>
    </div>
    </>
  );
};
